
import { useState } from 'react';
import NavBar from '@/components/NavBar';
import { PomodoroTimer } from '@/components/PomodoroTimer';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';

export default function PomodoroPage() {
  const [isFullscreen, setIsFullscreen] = useState(false);
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#9b87f5] to-[#7E69AB] text-white">
      <NavBar />
      
      <div className="container mx-auto px-4 py-12">
        <div className="flex justify-between items-center mb-12">
          <Link to="/">
            <Button variant="ghost" className="text-white hover:bg-white/20">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Dashboard
            </Button>
          </Link>
        </div>
        
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-3">Focus Timer</h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">
            Enhance your productivity with the Pomodoro technique
          </p>
        </div>
        
        {/* Pomodoro Timer Card with increased padding and height */}
        <div className="mb-20">
          <Card className="max-w-4xl mx-auto bg-white/10 backdrop-blur-md rounded-xl shadow-xl border-white/20">
            <CardContent className="p-8 md:p-16 pb-20 min-h-[400px]">
              <PomodoroTimer />
            </CardContent>
          </Card>
        </div>
        
        {/* About Section */}
        <div className="mt-24">
          <Card className="max-w-3xl mx-auto bg-white/10 backdrop-blur-md rounded-xl shadow-lg border-white/20">
            <CardContent className="p-8 md:p-12">
              <h2 className="text-2xl font-semibold mb-6">About the Pomodoro Technique</h2>
              <p className="text-white/90 mb-8 leading-relaxed text-lg">
                The Pomodoro Technique is a time management method developed by Francesco Cirillo in the late 1980s. 
                The technique uses a timer to break down work into intervals, traditionally 25 minutes in length, 
                separated by short breaks.
              </p>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 shadow-inner">
                <h3 className="text-xl font-medium mb-6">Basic Steps:</h3>
                <ol className="list-decimal pl-8 space-y-4">
                  <li className="pl-2 text-lg">Choose a task to be accomplished</li>
                  <li className="pl-2 text-lg">Set the Pomodoro timer (traditionally to 25 minutes)</li>
                  <li className="pl-2 text-lg">Work on the task until the timer rings</li>
                  <li className="pl-2 text-lg">Take a short break (5 minutes)</li>
                  <li className="pl-2 text-lg">After four pomodoros, take a longer break (15-30 minutes)</li>
                </ol>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
